import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    // With a desktop and a mobile video, each one only loads on its own screen size (data-media)
    const { media } = this.dataset;
    if (media) {
      const query = window.matchMedia(media);
      if (!query.matches) {
        const onChange = () => {
          if (!query.matches) return;
          query.removeEventListener('change', onChange);
          this.#load();
        };
        query.addEventListener('change', onChange);
        return;
      }
    }

    this.#load();
  }

  #load() {
    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
